function registerTabButtons() {
  const activeClass = "active";
  const tabButtons = document.querySelectorAll(".drawer__tabs-button");

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      if (button.classList.contains('type-link')) { 
        return;
      }

      const tabId = button.dataset.tabId;
      const tabPanel = document.querySelector(`.drawer__tabs-panel[data-tab-id="${tabId}"]`);

      document.querySelectorAll(".drawer__tabs-button").forEach((button) => {
        button.classList.remove(activeClass);
      });

      document.querySelectorAll(".drawer__tabs-panel").forEach((tab) => {
        tab.classList.remove(activeClass);
      });

      button.classList.add(activeClass);
      tabPanel.classList.add(activeClass);
    });
  });
}

function registerMobileMenuAccordions() {
  const menuHeaders = document.querySelectorAll(".tab-menu--header");

  menuHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      header.closest('.tab-menu').classList.toggle("active");
    });
  });
}

registerTabButtons();
registerMobileMenuAccordions();
